var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"centered-message"},[_c('h5',{staticClass:"title"},[_vm._t("title")],2),(_vm.spinner)?_c('Spinner',{staticClass:"spinner",attrs:{"small":""}}):_vm._e(),_c('div',{staticClass:"body"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }